import React from "react"
import { cn } from "../../utils/cn"

export type StatAccent = "neutral" | "primary" | "success" | "warning" | "danger"

interface StatTileProps {
    label: string
    value: React.ReactNode
    accent?: StatAccent
    active?: boolean
    onClick?: () => void
}

const accentDot: Record<StatAccent, string> = {
    neutral: "bg-primary",
    primary: "bg-primary",
    success: "bg-success",
    warning: "bg-warning",
    danger: "bg-danger",
}

/**
 * Tile de resumo/KPI. Se receber `onClick` vira botão (ex.: atalho de filtro);
 * senão, um card informativo.
 */
const StatTile: React.FC<StatTileProps> = ({
    label,
    value,
    accent = "neutral",
    active,
    onClick,
}) => {
    const clickable = typeof onClick === "function"
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={!clickable}
            className={cn(
                "flex flex-col items-start rounded-xl border bg-surface px-4 py-3 text-left transition-colors",
                clickable && "hover:border-border-strong",
                !clickable && "cursor-default",
                active
                    ? "border-primary ring-1 ring-primary/40"
                    : "border-border"
            )}
        >
            <span className="flex items-center gap-2 text-xs font-medium uppercase tracking-wide text-muted">
                <span
                    className={cn("h-2 w-2 rounded-full", accentDot[accent])}
                />
                {label}
            </span>
            <span className="mt-1 text-2xl font-bold text-text">{value}</span>
        </button>
    )
}

export default StatTile
